export const isGoogleTagSet = () => Boolean(window.gtag);

export const initGoogleTagTracking = () => {
    if (isGoogleTagSet()) {
        const { pottsalatId } = window.cookie.get();
        gtag("config", reactConfig.google_tag, {
            user_id: pottsalatId,
        });
    }
};

const trackEvent = (eventName, additionalData) => {
    if (!isGoogleTagSet()) {
        return;
    }

    // eslint-disable-next-line no-console
    console.log(eventName, additionalData);

    gtag("event", eventName, additionalData);
};

export default {
    trackAddToCartEvent: (additionalData) =>
        trackEvent("add_to_cart", additionalData),
    trackCompleteOrderEvent: (additionalData) =>
        trackEvent("purchase", additionalData),
    trackItemViewEvent: (additionalData) =>
        trackEvent("view_item", additionalData),
    trackPostcodePopup: (name, additionalData = undefined) => {
        trackEvent(`postcode_${name}`, additionalData);
    },
};
